import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

/**
 * Provides the Transloco scope for auth-page features carousel cards.
 *
 * Scope details:
 * - Scope: `shared-features-carousel` — used in templates as `*transloco="let t; prefix: 'sharedFc'"`.
 * - Translations: `en.json` / `ar.json` in this folder.
 *
 * @returns Angular provider declaring the shared features-carousel scope.
 * @example
 * ```ts
 * @Component({
 *   providers: [provideTranslocoScopeSharedFeaturesCarousel()],
 * })
 * export class CarouselFeatureCardComponent {}
 * ```
 */
export function provideTranslocoScopeSharedFeaturesCarousel(): Provider {
  return provideTranslocoScope({
    alias: 'sharedFc',
    loader: i18nLoader,
    scope: 'shared-features-carousel',
  });
}
